<div class="alert-comment-section-container">
  <div *ngIf="this.model.commentsList$().length > 0" class="alert-comment-section-posted-comments-container">
    <ng-container *ngFor="let comment of this.model.commentsList$()">
      <div class="alert-comment-section-posted-comment-timestamp">
        {{comment.__displayTimestamp}}
      </div>
      <div class="alert-comment-section-posted-comment">
        <ng-container *ngIf="comment.userId === this.model.currentUserId$()">
          <div class="text-area-avatar text-area-avatar-right">
                        <textarea  [placeholder]="'t.commonTableFiltering'| translate" disabled maxlength="5000" [(ngModel)]="comment.comments">
                        </textarea>
          </div>
          <link-user-avatar></link-user-avatar>
        </ng-container>

        <ng-container *ngIf="comment.userId !== this.model.currentUserId$()">
          <link-user-avatar [userId]="comment.userId"></link-user-avatar>
          <div class="text-area-avatar text-area-avatar-left">
                        <textarea [placeholder]="'t.commonTableFiltering'| translate" disabled maxlength="5000" [(ngModel)]="comment.comments">
                        </textarea>
          </div>
        </ng-container>
      </div>
    </ng-container>
  </div>
  <div class="alert-comment-section-comment-input-container">
    <div class="alert-comment-section-comment-input">
      <div class="text-area-avatar text-area-avatar-right">
                <textarea  [placeholder]="'t.commonTableFiltering'| translate" maxlength="5000" [(ngModel)]="commentMessage">
                </textarea>
      </div>
      <link-user-avatar></link-user-avatar>
    </div>
    <div class="d-flex justify-content-end">
      <button mat-flat-button class="alert-comment-section-submit-button" type="submit" (click)="postComment(commentMessage); commentMessage = ''">Comment</button>
    </div>
  </div>
</div>
